<template>
  <div
    class="question-container"
    :style="{
      border:
        dataObj.status === 1
          ? '1px dashed rgba(58,96,255,1)'
          : '1px solid #EDEFF2',
    }"
  >
    <!-- 题目类型标签 -->
    <div class="question-type">图片多选</div>

    <!-- 题目标题 -->
    <div class="title-view">
      <!-- <span style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
          <b v-if="isCountMust">
            {{ `(必须选${maxCount}项)` }}
          </b>
          <b v-else-if="isCountSwitch">
            {{ `(最多选${maxCount}项，最少${minCount}项)` }}
          </b>
          <b v-else>
            {{ `(最多选${maxCount}项)` }}
          </b>
        </span>
      </span> -->

      <p class="question-row">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        <span class="index">{{
          `${dataObj.questionIndex || index + 1}、`
        }}</span>

        <!-- 富文本 + 后缀文字 放在同一个容器里 -->
        <span class="rich-text-wrapper">
          <span class="rich-text-content" v-html="dataObj.caseProblem"></span>
          <span class="suffix-text">
            <b v-if="isCountMust">
              {{ `(必须选${maxCount}项)` }}
            </b>
            <b v-else-if="isCountSwitch">
              {{ `(最多选${maxCount}项，最少${minCount}项)` }}
            </b>
            <b v-else>
              {{ `(最多选${maxCount}项)` }}
            </b>
          </span>
        </span>
      </p>
    </div>

    <!-- 题目图片展示 -->
    <div class="question-images">
      <div
        v-for="(item, index) in images"
        :key="index"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" style="width: 100%" />
      </div>
    </div>

    <!-- 选项列表（网格布局） -->
    <div
      class="image-options"
      :style="`grid-template-columns: repeat(${repeat}, 1fr)`"
    >
      <div
        v-for="(option, index) in list"
        :key="index"
        class="option-wrap"
        :style="{ paddingBottom: option.context === '' ? '80px' : '0' }"
      >
        <div class="option-item">
          <!-- 选项图片 -->
          <div class="image-view">
            <img
              :src="option.img_path"
              class="img"
              @click.stop="showBigImage(option.img_path, option)"
              style="cursor: pointer"
            />
          </div>

          <!-- 选项标题（禁用状态） -->
          <div class="content-box">
            <input
              type="text"
              v-model="option.text"
              :disabled="true"
              class="input-placeholder"
            />
          </div>

          <!-- 选项说明（禁用状态） -->
          <div v-if="option.context" class="content-box">
            <textarea
              v-model="option.context"
              maxlength="500"
              :disabled="true"
            ></textarea>
          </div>

          <!-- 单选复选框 -->
          <div class="content-box checkbox-wrap">
            <el-checkbox
              :value="option.isChoose"
              label="选择"
              size="mini"
              @change="(val) => changeCheckbox(val, index)"
            ></el-checkbox>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片预览弹窗（替代小程序自定义弹窗） -->
    <el-dialog
      title="图片预览"
      :visible.sync="fangdaShow"
      width="60%"
      @close="fangdaClose"
    >
      <div class="popup-scroll">
        <div>{{ fangdaTitle }}</div>
        <img :src="fangdaImgUrl" style="width: 100%" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "QuestionImageRadioView",
  // Vue2 定义Props
  props: {
    params: {
      type: Object,
      default: () => ({}), // 避免对象引用问题
    },
    repeat: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      dataObj: {},
      answerObj: {},
      index: 0,
      list: [],
      count: 3,
      isMultiple: true,
      startColor: { r: 58, g: 96, b: 255 },
      endColor: { r: 58, g: 96, b: 255 },
      themeColor: { r: 58, g: 96, b: 255 },
      images: [],
      rules: [],
      // 替代 Vue3 的 ref
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
      isCountMust: null,
      maxCount: null,
      minCount: null,
      isCountSwitch: null,
    };
  },
  // Vue2 监听属性
  watch: {
    // 监听 props.dataObj 变化
    params: {
      handler(newValue) {
        // 深拷贝避免引用问题
        this.dataObj = newValue.data;
        this.index = newValue.index || 0;
        // 解析题目图片
        this.images = JSON.parse(newValue.data.caseProblemImg);
        // 解析选项列表
        this.list = JSON.parse(newValue.data.chooseList).list;
        console.log(this.list, "ihiuewgriuwqeuwieqiuweg1uieg12iueg1i2ueg12iu");

        this.isCountMust = JSON.parse(newValue.data.chooseList).isCountMust;
        this.maxCount = JSON.parse(newValue.data.chooseList).maxCount;
        this.minCount = JSON.parse(newValue.data.chooseList).minCount;
        this.isCountSwitch = JSON.parse(newValue.data.chooseList).isCountSwitch;
      },
      immediate: true, // 初始加载触发
      deep: true, // 深度监听对象内部变化
    },
  },
  methods: {
    // 复选框切换（单选逻辑：选中一个，其他取消）
    changeCheckbox(val, index) {
      console.log("[][]12[e]12rp12]rp12]rp1]2]", this.list);
      const num = this.list.filter((item) => {
        return item.isChoose === true;
      }).length;
      console.log(
        "[][]12[e]12rp12]rp12]rp1]2]",
        this.list,
        this.list[index].isChoose,
      );
      console.log(this.maxCount, this.minCount, num);
      if (this.list[index].isChoose === true) {
        console.log("取消选择hahahahahahaha");
        this.list[index].isChoose = false;
      } else {
        console.log("this.isCountMust", this.isCountMust);
        console.log("this.isCountSwitch", this.isCountSwitch);

        if (this.isCountMust) {
          // 如果最多选 必选打开
          if (num === this.maxCount) {
            this.$message({
              message: "必须选择" + this.maxCount + "项",
              type: "warning",
            });
            setTimeout(() => {
              this.list[index].isChoose = false;
            }, 0);
            return;
          }
        } else {
          if (num >= this.maxCount) {
            this.$message({
              message: "最多可选择" + this.maxCount + "项",
              type: "warning",
            });
            setTimeout(() => {
              this.list[index].isChoose = false;
            }, 0);
            return;
          }
        }
        console.log("77777777777");
        this.list[index].isChoose = true;
      }

      // if (val) {
      //   // 选中当前选项，取消其他所有选项
      //   this.list = this.list.map((item, i) => ({
      //     ...item,
      //     isChoose: i === index,
      //   }));
      // } else {
      //   // 取消当前选项
      //   this.list[index].isChoose = false;
      // }

      // 更新选项列表JSON
      this.dataObj.chooseList = JSON.stringify({
        list: this.list,
        minCount: this.minCount,
        maxCount: this.maxCount,
        isCountMust: this.isCountMust,
        isCountSwitch: this.isCountSwitch,
      });

      // 组装答案对象
      this.answerObj = {
        question_id: this.dataObj.id,
        type: this.dataObj.type,
        answer: this.list
          .filter((item) => item.isChoose === true)
          .map((item) => ({ id: item.id })),
        if_hide: this.dataObj.if_hide,
      };

      // 触发update事件
      this.$emit(
        "update",
        JSON.stringify({
          data: this.dataObj,
          index: this.index,
          answer: this.answerObj,
        }),
      );
    },
    // 提交答案事件
    handleAnswerClick() {
      if (this.dataObj.status !== 4) return;

      this.answerObj.if_hide = this.dataObj.if_hide;
      // 触发answer事件
      this.$emit(
        "answer",
        JSON.stringify({
          data: this.dataObj,
          index: this.index,
          answer: this.answerObj,
        }),
      );
    },
    // 逻辑设置事件（空方法保留）
    handleLogicClick() {},
    // 预览大图
    showBigImage(img, option) {
      this.fangdaShow = true;
      this.fangdaImgUrl = img;
      this.fangdaTitle = option.text || "";
    },
    // 关闭大图预览
    fangdaClose() {
      this.fangdaShow = false;
      this.fangdaImgUrl = "";
      this.fangdaTitle = "";
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

// 选项网格布局
.image-options {
  margin: 10px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px; // 20rpx → 10px
  justify-content: space-between;

  .option-wrap {
    display: flex;
    justify-content: center;
  }
}

// 选项卡片
.option-item {
  width: 185px; // 320rpx → 185px
  border: 1px solid #d4d4d4; // 1rpx → 1px
  border-radius: 6.5px; // 13rpx → 6.5px
  overflow: hidden;
}

// 选项图片区域
.image-view {
  width: 185px; // 320rpx → 185px
  height: 185px; // 320rpx → 185px
  background: #f4f4f4;
  border-radius: 6.5px; // 13rpx → 6.5px
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;

  .img {
    width: 100%;
    height: 100%;
    object-fit: cover; // 替代小程序的aspectFill
  }
}

// 选项输入框容器
.content-box {
  width: 185px; // 320rpx → 185px
  padding: 6.5px 10px; // 13rpx 20rpx → 6.5px 10px
  border-radius: 4px; // 8rpx → 4px
  margin-top: 10px; // 20rpx → 10px

  input {
    width: 100%;
    font-size: 16px; // 32rpx → 16px
    color: #2b2f36;
    text-align: center;
    font-weight: 600;
    border: none;
    outline: none;
    background: transparent;
  }

  textarea {
    width: 100%;
    font-size: 14px; // 28rpx → 14px
    color: #2b2f36;
    line-height: 20px; // 40rpx → 20px
    height: 60px; // 120rpx → 60px
    resize: none;
    border: none;
    outline: none;
    background: transparent;
  }

  .input-placeholder::placeholder {
    color: #999;
  }
}

// 复选框容器
.checkbox-wrap {
  display: flex;
  justify-content: center;
  padding: 5px 0;
}

// 图片预览弹窗
.popup-scroll {
  width: 100%;
  padding: 10px;

  div {
    font-size: 16px;
    margin-bottom: 10px;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewImageMcq.vue